
<template>
  <Loader v-if="loader" />

  <div class="formgrid grid">
    <div class="col-12 mt-1 mb-4">
      <label> <small>Incassi previsionati il giorno:</small> </label>
      <Calendar v-model="previsionalDates" @date-select="onDateSelected" selectionMode="multiple" placeholder="Seleziona previsione del giorno..." dateFormat="dd/mm/yy"  class="w-full mt-1" showIcon />
    </div>


    <div class="col-12 md:col-6">
      <div class="card">
        <div class="grid">
          <div class="col-12"> <h5>Previsionale incassi <small>(singolo giorno)</small></h5></div>
        </div>
        <div v-if="incassi.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefIncassi" type="bar" :data="incassi" @select="getDetails($event, 'incassi')" class="w-full" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefIncassi)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div> 
    </div>

    <div class="col-12 md:col-6">
      <div class="card">
        <div class="grid">
          <div class="col-12"> <h5>Previsionale uscite <small>(singolo giorno)</small></h5></div>
        </div>
        <div v-if="uscite.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefUscite" type="bar" :data="uscite" @select="getDetails($event, 'uscite')" class="w-full" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefUscite)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div> 
    </div>

    <div class="col-12">
      <div class="card">
        <div class="grid">
          <div class="col-12 mb-4">
            <h5 class="mb-0">Previsionale profitto </h5>
            <small>Comprensive di liquidità iniziale ({{liquidityBanche.join(',')}} = {{liquidity}})</small>
          </div>
        </div>
        
        <div v-if="incassiSum.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefIncassiSum" type="line" :data="incassiSum" class="w-full" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefIncassiSum)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div> 
    </div>

  </div>

  <!-- Dialog previsional details uscite -->
  <Dialog v-model:visible="dialogDetails" modal header="Dettagli" :style="{ width: '80vw'}">
    <DataTable :value="details" tableStyle="width: 100%">
      <Column field="numero" header="Fattura">
        <template #body="{data}">
          <p v-if="data.type == 'incassi'">
             <router-link :to="`/ask/clienti/fatture/${data.numero}/dettagli`" target="_blank">
              {{data.numero}}
            </router-link>
          </p>
          <p v-else>
             <router-link :to="`/ask/acquisto/fatture/${data.id}/dettagli`" target="_blank">
              {{data.numero}}
            </router-link>
          </p>
        </template>
      </Column>
      <Column field="totale_fattura" header="Totale Fattura">
        <template #body="{data}">
          {{formatCurrency(data.totale_fattura)}} 
        </template>
      </Column>
      <Column field="ragsoc" header="Cliente/Fornitore"></Column>
      <Column field="previsione" header="Previsione Del">
        <template #body="{data}">
          {{formatDate(data.previsione)}}
        </template>
      </Column>
        <ColumnGroup type="footer">
        <Row>
            <Column footer="Totale:" :colspan="1" footerStyle="text-align:right" />
            <Column :footer="totalDetails" />
            <Column :colspan="2" />
        </Row>
      </ColumnGroup>
    </DataTable>
  </Dialog>
  

</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import DashboardService from '@/services/ask-pratiche/pratiche-dashboard'
import { ref, getCurrentInstance, onMounted, watch, computed } from 'vue';
import Loader from '@/components/Loader.vue'
import SkeletonCustom from '@/components/SkeletonCustom.vue'
import { useToast } from "primevue/usetoast";

export default {
    components: {
      Loader,
      SkeletonCustom,
    },
    setup() {

      const loader = ref(false)
      const self = getCurrentInstance();
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const toast = useToast();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const dashboardService = new DashboardService(self.$http, self.$eventBus)
      const items = ref();
      const details = ref();
      const dialogDetails = ref(false)
      const liquidity = ref(0);
      const liquidityBanche = ['BPM', 'POSTA', 'MPS'];
      const previsionalDates = ref([]);
      const chartRefIncassi = ref(null);
      const incassi = ref({
          labels: [],
          datasets: [
              {
                label: 'Incasso (ultima previsione)',
                backgroundColor: '#dcf797',
                data: []
              },           
          ]
      });
      const chartRefIncassiSum = ref(null);
      const incassiSum = ref({
          labels: [],
          datasets: [
              {
                label: 'Profitto (ultima previsione)',
                borderColor: '#fa4d59',
                data: [],
                tension: 0.4,
                prevision: 'Ultima'
              },           
          ]
      });
      const uscite = ref({
          labels: [],
          datasets: [
              {
                label: 'Uscite (ultima previsione)',
                backgroundColor: '#f57047',
                data: []
              },           
          ]
      });


      onMounted(() => {
        getLiquidity()
        getPrevisionaleIncassi()
      })

      const getLiquidity = () => {
        loader.value = true
        dashboardService.getLiquidity()
        .then((res) => {
          if (res.items.length > 0) {
            liquidity.value = res.items.filter(el => liquidityBanche.includes(el.name)).reduce((acc, curr) =>  acc + parseFloat(curr.tot), 0);
          }
        })
        .finally(()=>{
          loader.value = false
        })
      }

      const getPrevisionaleIncassi = () => {
        loader.value = true
        service.getPrevisionaleIncassi()
        .then((res) => {
          if (res.items.incassi.length > 0) {
            items.value = res.items.incassi
            buildGraphIncassi()
            buildGraphIncassiSum()
            buildGraphUscite()
          }
        })
        .finally(()=>{
          loader.value = false
        }) 
      }

      const buildGraphIncassi = () => {
        let data = []
        items.value.forEach(el => {
          incassi.value.labels.push(moment(new Date(el.data)).locale('it').format('DD MMM YYYY').toUpperCase())
          data.push(el.incasso)
        });
        incassi.value.datasets[0].data = data         
      };

      const buildGraphIncassiSum = () => {
        let data = []
        let tot = liquidity.value;
        
         items.value.forEach((el,k) => {
          incassiSum.value.labels.push(moment(new Date(items.value[k].data)).locale('it').format('DD MMM YYYY').toUpperCase())
          tot += el.incasso - el.uscita
          data.push(tot)
        });
        incassiSum.value.datasets[0].data = data

      };

      const buildGraphUscite = () => {
        let data = []
        items.value.forEach(el => {
          uscite.value.labels.push(moment(new Date(el.data)).locale('it').format('DD MMM YYYY').toUpperCase())
          data.push(el.uscita)
        });
         uscite.value.datasets[0].data = data         
      };
      

      watch(previsionalDates, (items, oldItems) => {
          if (items.length < oldItems.length) {
            let old_dates = oldItems.map(date => moment(date).format('YYYY-MM-DD'));
            let new_dates = items.map(date => moment(date).format('YYYY-MM-DD'));
            const diff = old_dates.filter(item => !new_dates.includes(item));
            incassiSum.value.datasets = incassiSum.value.datasets.filter(el => el.prevision != diff[0])
            incassi.value.datasets = incassi.value.datasets.filter(el => el.prevision != diff[0])
            uscite.value.datasets = uscite.value.datasets.filter(el => el.prevision != diff[0])
          } 
      })

      const onDateSelected = (date) => {
        let d = moment(new Date(date)).format('YYYY-MM-DD')
        addPrevisionalDates(d)
      }

      const addPrevisionalDates = (d) => { 
        loader.value = true
        service.addPrevisionalDates([d])
        .then((res) => {
          injectDates(res.items)
        })
        .finally(()=>{
          loader.value = false
        }) 
      }



      const injectDates = (items) => {
        
        for (const [date, els] of Object.entries(items)) {
           let isEmpty = els.every(el => el.incasso == 0);
           if (isEmpty) {
            let dObj = new moment(date)
            previsionalDates.value =  previsionalDates.value.filter(d => new Date(d).getTime() !== new Date(dObj._d).getTime())
            delete items[date]
            toast.add({severity:'warn', summary: 'Rimossa', detail: `Data ${moment(date).format('DD/MM/YYYY')} rimossa perchè non esiste una previsione per quella data`});
           }
        }

        for (const [date, els] of Object.entries(items)) {
          let totSum = liquidity.value;
          let valSum = [];
          let val = [];
          let valUscite = [];
          let randColor = getRandomColor()
          els.forEach(el => {
            totSum += el.incasso - el.uscita
            valSum.push(totSum)
            val.push(el.incasso)
            valUscite.push(el.uscita)
          });
          let tempSum = {
            label: `Profitto (previsione del ${moment(date).format('DD/MM/YYYY')})`,
            backgroundColor: randColor,
            borderColor: randColor,
            data: valSum,
            tension: 0.4,
            prevision: date
          }
          let temp = {
            label: `Incasso (previsione del ${moment(date).format('DD/MM/YYYY')})`,
            backgroundColor: randColor,
            borderColor: randColor,
            data: val,
            prevision: date
          }
          let tempUscite = {
            label: `Uscite (previsione del ${moment(date).format('DD/MM/YYYY')})`,
            backgroundColor: randColor,
            borderColor: randColor,
            data: valUscite,
            prevision: date
          }

          incassiSum.value.datasets.push(tempSum)
          incassi.value.datasets.push(temp)
          uscite.value.datasets.push(tempUscite)
        }

      }

      const getDetails = (e, type) => {
        
        let inputDate = uscite.value.labels[e.element.index];
        const [day, monthAbbr, year] = inputDate.split(' ');
        //Troviamo l'indice dell'abbreviazione italiana nell'elenco dei nomi brevi dei mesi in italiano
        const italianMonthIndex = moment.localeData('it').monthsShort().indexOf(monthAbbr.toLowerCase());
        //Otteniamo il nome breve del mese in inglese
        const englishMonthAbbr = moment.localeData('en').monthsShort()[italianMonthIndex];
        //Creiamo un oggetto Moment.js con la data italiana e il formato corretto
        const momentDate = moment(`${day} ${englishMonthAbbr} ${year}`, 'DD MMM YYYY');
        //Otteniamo la data in formato 'YYYY-MM-DD'
        const convertedDate = momentDate.format('YYYY-MM-DD');

        if (moment(convertedDate).isValid()) {
          details.value = []
          loader.value = true
          service.getDetailsPrevisionalIncassiUscite(convertedDate)
          .then((res) => {
            if (res.items[type].length > 0) {
              details.value = res.items[type]
              // totalDetails()
              dialogDetails.value = true
            } else {
              toast.add({severity:'warn', summary: 'Nessun Dettaglio', detail: `Non ci sono dettagli per la data ${inputDate} `});
            }
          })
          .finally(()=>{
            loader.value = false
          }) 
        } 

      }

      const totalDetails = computed(() => {
          let total = 0;
          for(let item of details.value) {
              total += item.totale_fattura;
          }

          return formatCurrency(total);
      });

      const getRandomColor = () => { 
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      }

      const exportChart = (refGraph) => {
        let imgGraph = refGraph.getBase64Image()       
        let a = document.createElement('a')   
        a.href = imgGraph
        a.download = 'chart-export.png'
        a.click()
        a = null
      }

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };



    return { 
      loader,
      items,
      incassi,
      uscite,
      chartRefIncassi,
      incassiSum,
      chartRefIncassiSum,
      previsionalDates,
      liquidityBanche,
      onDateSelected,
      exportChart,
      getDetails,
      dialogDetails,
      details,
      formatDate,
      liquidity,
      formatCurrency,
      totalDetails
    }
  }
}
</script>


